import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, makeObservable, } from 'mobx';
import { type NoteInfo } from '@root/models/NoteInfo';
import { PromiseCompletion } from '@classes/PromiseCompletion';
import { type IModalDialogContent, type ModalButtonOptions, ModalButtonType, type ModalDialogOptions, ModalWindow } from '@components/Modal';

export type RenameNoteDialogProps = {
  note: NoteInfo;
};

@observer
export default class RenameNoteDialog extends React.Component<RenameNoteDialogProps> implements IModalDialogContent<string> {
  @observable private _name: string;
  private _loader: PromiseCompletion = new PromiseCompletion();
  private _inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  constructor(props: RenameNoteDialogProps){
    super(props);
    makeObservable(this);

    const { note } = this.props;
    
    this._name = note.name;
  }

  componentDidMount(){
    this._inputRef.current?.select();
  }

  public getModalOptions(window: ModalWindow<string>): ModalDialogOptions<string> {
    const buttons: ModalButtonOptions<string>[] = [];
    
    buttons.push({
      type: ModalButtonType.Cancel,
      onClick: () => {
        window.close();
      }
    });
    buttons.push({
      title: 'Rename',
      type: ModalButtonType.Save,
      onClick: async () => {
        await this._onSaveClick(window);
        window.close(ModalButtonType.Save);
      }
    });

    return {
      title: `Rename note`,
      width: 600,
      buttons: buttons,
      loader: this._loader
    };
  }

  render(){
    return (
      <>
        <div className="form-group">
          <label className="form-control-label">Name</label>
          <input className="form-control" ref={this._inputRef} autoFocus type="text" value={this._name} onChange={(e) => this._name = e.target.value} />
        </div>
      </>
    );
  }
  
  @action.bound
  private async _onSaveClick(window: ModalWindow<string>){
    window.close(ModalButtonType.Ok, this._name);
  }
}